import React from 'react';
import styles from './PreviousLoanCommunicationHistory.module.scss';
import cx from 'classnames';
import Chip from '@primitives/Chip';
import { DateFormat, getFormatDate } from 'src/utils/DateHelper';
import { IPreviousLoanAccount } from '../../interfaces/CaseDetail.type';

export interface ILanGroup {
  lan: IPreviousLoanAccount;
  onChipSelect: (lanValue: string, caseReferenceId: string) => void;
  selectedLAN: string;
}
const LanGroup: React.FC<ILanGroup> = props => {
  const { onChipSelect, lan, selectedLAN } = props;
  return (
    <div className={styles.lanGroupContainer}>
      <Chip
        key={lan.accountNumber}
        label={`LAN : ${lan.accountNumber} \u00A0\u00A0 ${getFormatDate(
          new Date(lan.startDate),
          DateFormat.DD_MMM_YYYY
        )}`}
        wrapperClasses={cx([
          styles.chip,
          { [styles.chipActiveColor]: lan.accountNumber === selectedLAN }
        ])}
        labelClasses={cx(styles.chipText, {
          [styles.selectedChipText]: lan.accountNumber === selectedLAN
        })}
        onChipClick={() => onChipSelect(lan.accountNumber, lan.caseReferenceId)}
      />
    </div>
  );
};

export default LanGroup;
